import operationService from "src/services/operationService";

export const GET_OPERATION_REQUEST = "@operation/operation-dashboard-request";
export const GET_OPERATION_SUCCESS = "@operation/operation-dashboard-success";
export const GET_OPERATION_FAILURE = "@operation/operation-dashboard-failure";

export function getListOperation(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_OPERATION_REQUEST});
      const response = await operationService.getListOperation(params);
      dispatch({
        type: GET_OPERATION_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_OPERATION_FAILURE});
      throw error;
    }
  };
}
